import { Toaster } from '@firmable/common';
import { useTranslation } from '@firmable/i18n';
import { Notification as NotificationStore } from '@web/store/Notification';
import React from 'react';

function Notification() {
  const { t } = useTranslation('common');
  const notifications = NotificationStore.use(({ notifications }) => notifications);
  const clearNotification = NotificationStore.use(({ clearNotification }) => clearNotification);

  const toasts = React.useMemo(
    () => Object.keys(notifications ?? {}).map((id) => ({ id, message: notifications[id] })),
    [notifications],
  );

  return <Toaster toasts={toasts} onDismiss={clearNotification} closeLabel={t('notifications.closeNotification')} />;
}

export { Notification };
